<template>
  <v-form ref="login" v-model="valid" lazy-validation>
    <v-text-field
      v-model="fieldsValues.username"
      :label="$t('login.form.email')"
      name="username"
      type="text"
      v-validate="'required|email'"
      :error-messages="errors.collect('username')"
      @keypress="enterWatcher"
      required
    ></v-text-field>

    <v-text-field
      v-model="fieldsValues.password"
      :label="$t('login.form.password')"
      name="password"
      type="password"
      v-validate="'required'"
      :error-messages="errors.collect('password')"
      @keypress="enterWatcher"
      required
    ></v-text-field>

    <v-checkbox
      v-model="fieldsValues.rememberMe"
      :label="$t('login.form.rememberMe')"
    ></v-checkbox>

    <v-btn block large color="primary" @click.prevent="submit">{{ $t('login.signIn') }}</v-btn>
  </v-form>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "LoginForm",
  props: {

  },
  data() {
    return {
      valid: true,
      fetchStatus: { 
        // -1 mean error
        // 1 mean success
        // 0 mean pending
        orders: 0,
        products: 0,
        ordersMap: 0,
      },
      fieldsValues: {
        username: '',
        password: '',
        rememberMe: false,
      },
    }
  },
  methods: {
    ...mapActions({
      login: 'security/login',
      updateOrders: 'order/updateOrders',
    }),
    enterWatcher(ev) {
      if (_.get(ev, 'keyCode') === 13 || _.get(ev, 'charCode') === 13) {
        this.submit();
      }
    },
    async submit() {
      try {
        const res = await this.$validator.validateAll();
        console.log(res);
        if (!res) {
          return;
        }
        const result = await this.login(this.fieldsValues);
        if (result === true) {
          if (this.isOnline){
            await this.fetchDataAfterLogin();
          } else {
            this.$emit('loggedSuccessfully');
          }
        } else {
          if (403 == result) {
            this.errors.add({
              field: 'password',
              msg: this.$t('login.msg.wrongPassword') 
            })
          } else {
            this.errors.add({
              field: 'password',
              msg: this.$t('login.msg.authError')
            })
          }
        }              
      } catch (e) {
        // @ts-ignore
        console.log(e);
      }
    },
    async fetchDataAfterLogin() {
      this.$emit('fetchingDataStateChange', true);
      try {
        await this.updateOrders();
        this.$emit('fetchingDataStateChange', false);
        this.$emit('loggedSuccessfully');
      } catch (e) {
        // toast or something similar can be used        
      }
    },
  },
  computed: {
    ...mapGetters({
      isOnline: 'isOnline'
    })
  }
}
</script>

<style lang="scss" scoped>

</style>